import { useTranslation } from 'react-i18next';

import { Text } from '~/components/ui/text';

export default function ContentQRBuilderHeader() {
  const { t } = useTranslation();

  return (
    <Text variant="h2" sx={{ marginBottom: '24px' }}>
      {t('editor:headerTitle')}
    </Text>
  );
}
